import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2, X, Check } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../common'

export const TableGeneralManagements = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllManagements } = FetchData
    const { dataManagements, loadingFetchAllManagements } = fetchAllManagements

    const { 
        handleClickFetchSpecificManagement,
        handleClickEnableDisableManagement,
        handleClickDeleteManagement
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "fecha", headerName: "Fecha", minWidth: 100, filter: true },
        { field: "identificador", headerName: "ID", minWidth: 100, filter: true },
        { field: "titulo", headerName: "Titulo", minWidth: 400, filter: true },
        // { field: "descripcion", headerName: "Descripción", minWidth: 400, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idgestion, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificManagement(idgestion, estado)}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickEnableDisableManagement(idgestion, 0)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Finalizar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableDisableManagement(idgestion, 1)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Reperturar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllManagements) && (<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataManagements}
                columnConfig={columnConfig}
            />
        </div>
    )
}
